import { Typography } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';

export const InstructionsText = ({ children }: PropsWithChildren) => (
  <Typography as="div" mb={4}>
    {children}
  </Typography>
);
